import { forwardRef, type SVGProps } from 'react';

export const ArticleExistsCheckErrorIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ArticleExistsCheckErrorIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_11004)">
        <path
          clipRule="evenodd"
          d="M32.1451 29.4927C32.4568 29.3224 32.6613 28.9918 32.6613 28.6112V19.5955C32.6613 19.2148 32.4568 18.8843 32.1451 18.714L24.4512 14.2663C24.2954 14.146 24.1006 14.0859 23.8961 14.0859C23.6916 14.0859 23.4968 14.146 23.3409 14.2663L15.647 18.714C15.3354 18.8843 15.1309 19.2148 15.1309 19.5955V28.6112C15.1304 28.7926 15.1782 28.9707 15.2692 29.1261C15.3602 29.2815 15.4909 29.4083 15.647 29.4927L23.3409 33.9404C23.4968 34.0606 23.6916 34.1207 23.8961 34.1207C24.1006 34.1207 24.2954 34.0606 24.4512 33.9404L32.1451 29.4927ZM18.0916 19.5955L23.8961 16.2397L29.7006 19.5955L23.8961 22.9513L18.0916 19.5955ZM26.6369 28.8954L28.5 27.0323L30.3631 28.8954C30.4328 28.9651 30.5215 29 30.6293 29C30.737 29 30.8257 28.9651 30.8954 28.8954C30.9651 28.8257 31 28.737 31 28.6293C31 28.5215 30.9651 28.4328 30.8954 28.3631L29.0323 26.5L30.8954 24.6369C30.9651 24.5672 31 24.4785 31 24.3707C31 24.263 30.9651 24.1743 30.8954 24.1046C30.8257 24.0349 30.737 24 30.6293 24C30.5215 24 30.4328 24.0349 30.3631 24.1046L28.5 25.9677L26.6369 24.1046C26.5672 24.0349 26.4785 24 26.3707 24C26.263 24 26.1743 24.0349 26.1046 24.1046C26.0349 24.1743 26 24.263 26 24.3707C26 24.4785 26.0349 24.5672 26.1046 24.6369L27.9677 26.5L26.1046 28.3631C26.0349 28.4328 26 28.5215 26 28.6293C26 28.737 26.0349 28.8257 26.1046 28.8954C26.1743 28.9651 26.263 29 26.3707 29C26.4785 29 26.5672 28.9651 26.6369 28.8954Z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
      </g>
      <defs>
        <clipPath id="clip0_1621_11004">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  );
});
